import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState, useMemo, useEffect } from "react";
import AdminTable from "../Administrator/Helpers/AdminTable";
import { getLink } from "src/store/Slices/ClientsSlice";
import dayjs from "dayjs";

const ClientLink = ({
  clientInfo,
  title,
  page,
  pageSize,
  setPage,
  setPageSize,
  mnemo,
  linkInfo,
  setLinkInfo,
  payload,
}) => {
  const dispatch = useDispatch();
  // const items = [
  //     {
  //         key: '1',
  //         label: 'Редактировать',
  //         onClick: () => { setIsOpenEditModal(true) },
  //         disabled: !mnemo?.children?.find(el => el.mnemo === 'updateBtn')
  //     },
  //     {
  //         key: '2',
  //         label: 'Удалить',
  //         onClick: () => { setOpenDeliteAbonementModal(true) },
  //         disabled: !mnemo?.children?.find(el => el.mnemo === 'deleteBtn')
  //     },
  // ];

  // STORE
  const linkList = useSelector((state) => state.ClientsSlice.getClientLinkList);
  const linkListLoading = useSelector(
    (state) => state.ClientsSlice.getClientLinkListLoading
  );

  const searchItemsMap = (keys, values) => {
    const formattedItems = {};
    if (keys && values) {
      keys.forEach((key, index) => {
        console.log(key, index);
        if (values[index] != undefined && values[index][0] != undefined) {
          if (key === "linkCreationDate") {
            formattedItems["linkCreationDate.From"] = dayjs(
              values[index][0]
            ).format("YYYY-MM-DD");
            formattedItems["linkCreationDate.To"] = dayjs(
              values[index][1]
            ).format("YYYY-MM-DD");
          } else {
            formattedItems[key] = values[index][0];
          }
        }
      });
      return formattedItems;
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const payload = searchItemsMap(
      Object.keys(filters),
      Object.values(filters)
    );
    dispatch(
      getLink({
        flag: "get",
        value: {
          UserId: clientInfo.id,
          count: pagination.pageSize,
          offset: pagination.pageSize * (pagination.current - 1),
          orderBy: sorter?.column?.dataIndex,
          isDesc: sorter.order
            ? sorter.order === "ascend"
              ? true
              : false
            : undefined,
          ...payload,
        },
      })
    );
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const onClickRowOne = (record) => {
    setLinkInfo(record);
  };

  const formatedLinkRows = useMemo(() => {
    return linkList?.data?.value?.rows?.map((element) => ({
      ...element,
      linkCreationDate: element.linkCreationDate
        ? dayjs(element?.linkCreationDate).format("DD.MM.YYYY HH:mm:ss")
        : "",
    }));
  }, [linkList]);

  return (
    <>
      {/* <SureModal
                visible={openDeliteAbonementModal}
                setVisible={setOpenDeliteAbonementModal}
                onClickYes={onClickYesDeleteComment}
            />
            <EditComment
                commentModal={isOpenEditModal}
                setCommentModal={setIsOpenEditModal}
                clientInfo={clientInfo}
                commentInfo={commentInfo}
                payload={payload}
            /> */}
      {window.innerWidth >= 768 && (
        <AdminTable
          scroll={{ x: 0, y: 200 }}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onChange={handleTableChange}
          loading={linkListLoading}
          onClickRowOne={onClickRowOne}
          columns={linkList}
          rows={formatedLinkRows}
          total={linkList?.data?.value?.totalCount}
          title={title}
          // items={items}
        />
      )}
    </>
  );
};

export default ClientLink;
